import { Close } from "@mui/icons-material";
import {
    Drawer,
    Button,
    Typography,
    Box,
    List,
    IconButton,
    Divider,
    Paper,
} from "@mui/material";
import React from "react";

import { DocumentInfo } from "../../../../../../../../models/documents";
import { TReadDocumentsDataResponse } from "../../../../../../../../services/budget/read-budget-documents";
import TemplateItem from "./TemplateItem";

interface ITemplateListProps {
    documentInfo: DocumentInfo & Partial<{ documentId?: string; date: string }>;
    templates: TReadDocumentsDataResponse;
    onApplyTemplate: (documentId: string) => void;
    onDeleteTemplate: (templateId: string) => void;
}

const TemplateList: React.FC<ITemplateListProps> = ({
    documentInfo,
    templates,
    onApplyTemplate,
    onDeleteTemplate,
}) => {
    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };

    return (
        <>
            <Button
                variant="outlined"
                onClick={toggleDrawer(true)}
                sx={{
                    backgroundColor: "rgba(139, 92, 246, 0.1)",
                    color: "#8B5CF6",
                    borderColor: "rgba(139, 92, 246, 0.3)",
                    "&:hover": {
                        backgroundColor: "rgba(139, 92, 246, 0.2)",
                        borderColor: "rgba(139, 92, 246, 0.5)",
                    },
                }}
            >
                Meus Documentos ({templates.length})
            </Button>

            <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box sx={{ width: { xs: "100vw", sm: 400 }, p: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                        }}
                    >
                        <Typography variant="h6">Documentos Salvos</Typography>
                        <IconButton onClick={toggleDrawer(false)}>
                            <Close />
                        </IconButton>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    {templates.length === 0 ? (
                        <Paper
                            variant="outlined"
                            sx={{
                                p: 4,
                                textAlign: "center",
                                backgroundColor: "background.default",
                            }}
                        >
                            <Typography color="text.secondary">
                                Nenhum documento salvo. Crie seções e salve-as
                                como um documento.
                            </Typography>
                        </Paper>
                    ) : (
                        <List sx={{ width: "100%" }}>
                            {templates.map((template) => {
                                const isDisabledDelete =
                                    template.document.id_e ===
                                    documentInfo.documentId;
                                return (
                                    <TemplateItem
                                        key={template.document.id_e}
                                        template={template.document}
                                        disableDelete={isDisabledDelete}
                                        onApply={() => {
                                            onApplyTemplate(
                                                template.document.id_e
                                            );
                                            toggleDrawer(false);
                                        }}
                                        onDelete={onDeleteTemplate}
                                    />
                                );
                            })}
                        </List>
                    )}
                </Box>
            </Drawer>
        </>
    );
};

export default TemplateList;
